<template>
  <v-card>
    <v-card-title>
      <h2>{{ editing ? 'Edit ' : 'Create ' }} Organization</h2>
      <span v-if="editing">{{ existing.name }}</span>
    </v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        :lazy-validation="true"
        @submit.prevent="onSave">

        <label>
          Organization Name*
        </label>
        <v-text-field
          v-model="organization.name"
          label="Name"
          single-line solo
          :rules="required"
          validate-on-blur />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="default-btn text" @click="$emit('cancel')">Cancel</v-btn>
      <v-btn color="default-btn green" @click="onSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formMixin } from '@/mixins'

export default {
  name: 'CreateEditOrganizationForm',
  mixins: [formMixin],
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    existing: {
      type: Object,
    },
  },
  data: () => ({
    organization: {},
  }),
  methods: {
    async onSave () {
      if (!this.$refs.form.validate()) return

      this.$emit('save', this.organization)
    },
  },
}
</script>

<style lang="scss" scoped></style>
